var _defs, _polygon, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamereWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb8bc91c-c730-4515-962f-47f674c1655c",
    "data-name": "camere",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bcb7fac7-8457-4a71-925c-dfe090eea308,.be389ad0-d772-4e8c-9113-051181b3d529{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.be389ad0-d772-4e8c-9113-051181b3d529{stroke-width:10px;}.bcb7fac7-8457-4a71-925c-dfe090eea308{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "camere_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "be389ad0-d772-4e8c-9113-051181b3d529",
    points: "5 15 5 195 195 195 195 80 80 80 41 90 41 5 5 15"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "bcb7fac7-8457-4a71-925c-dfe090eea308",
    x1: 41.43,
    y1: 92.09,
    x2: 6.5,
    y2: 102.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "bcb7fac7-8457-4a71-925c-dfe090eea308",
    x1: 41.43,
    y1: 93.17,
    x2: 41.43,
    y2: 194.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "bcb7fac7-8457-4a71-925c-dfe090eea308",
    x1: 7.5,
    y1: 143.5,
    x2: 41.43,
    y2: 143.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "bcb7fac7-8457-4a71-925c-dfe090eea308",
    x1: 62.81,
    y1: 83.64,
    x2: 62.81,
    y2: 195
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "bcb7fac7-8457-4a71-925c-dfe090eea308",
    x1: 92.5,
    y1: 79.5,
    x2: 92.5,
    y2: 194.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "bcb7fac7-8457-4a71-925c-dfe090eea308",
    x1: 160.5,
    y1: 79.5,
    x2: 160.5,
    y2: 195.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "bcb7fac7-8457-4a71-925c-dfe090eea308",
    x1: 173.85,
    y1: 80,
    x2: 173.85,
    y2: 194.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "bcb7fac7-8457-4a71-925c-dfe090eea308",
    x1: 194.5,
    y1: 137.5,
    x2: 160.5,
    y2: 137.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "bcb7fac7-8457-4a71-925c-dfe090eea308",
    x1: 193.5,
    y1: 97.5,
    x2: 160.5,
    y2: 97.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "bcb7fac7-8457-4a71-925c-dfe090eea308",
    x1: 21.75,
    y1: 10.35,
    x2: 21.75,
    y2: 97.14
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamereWhite);
export default __webpack_public_path__ + "static/media/camere_white.eccf4b950eb7be7a37f3e9553b1782ca.svg";
export { ForwardRef as ReactComponent };